import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://danielbricen.com";

const DEFAULT_TITLE =
	"Daniel Briceño | Representante a la Cámara por Bogotá";

/**
 * Rutas con contenido propio. Las que no aparecen aquí (/denuncias, /contacto,
 * /about) renderizan exactamente la misma landing que "/", así que apuntan su
 * canonical al home en lugar de auto-canonicalizarse.
 */
const ROUTES: Record<string, { path: string; title: string }> = {
	"/": { path: "/", title: DEFAULT_TITLE },
	"/blogs": {
		path: "/blogs",
		title: "Noticias | Daniel Briceño",
	},
	"/reporta-la-basura-de-tu-barrio": {
		path: "/reporta-la-basura-de-tu-barrio",
		title: "Reporta la basura de tu barrio | Daniel Briceño",
	},
};

const setCanonical = (href: string) => {
	let link = document.querySelector<HTMLLinkElement>(
		'link[rel="canonical"]'
	);
	if (!link) {
		link = document.createElement("link");
		link.setAttribute("rel", "canonical");
		document.head.appendChild(link);
	}
	link.setAttribute("href", href);
};

/**
 * El hosting reescribe todas las rutas a index.html, que trae un canonical fijo
 * al home. Sin esto cada ruta indexable se auto-descarta del índice.
 */
const Canonical = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		// Las entradas de blog son dinámicas: su canonical es su propia URL.
		if (pathname.startsWith("/blog/")) {
			setCanonical(`${SITE_URL}${pathname}`);
			return;
		}

		const route = ROUTES[pathname] ?? ROUTES["/"];
		setCanonical(`${SITE_URL}${route.path}`);
		document.title = route.title;
	}, [pathname]);

	return null;
};

export default Canonical;
